import { render, staticRenderFns } from "./collectionOfScrapFeesForLogisticsModal.vue?vue&type=template&id=59d60c1c"
import script from "./collectionOfScrapFeesForLogisticsModal.vue?vue&type=script&lang=js"
export * from "./collectionOfScrapFeesForLogisticsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports